<template>

  <div>
    <Modal
      :title="$t('titles.delete_product')"
      :submit="submit"
      :submit-label="$t('actions.delete')"
      :submitting="submitting"
    >

      <p>
        {{ $t('alerts.confirm_delete_product', {product_name: product.name}) }}      
      </p>

    </Modal>
  </div>

</template>

<script setup lang="ts">

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Modal from '../../Modal.vue'
// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'
import Product from '../../../models/Product'
import NotificationService from '../../../services/NotificationService'

interface Props {
  product: Product
}

const props = defineProps<Props>()

const { t } = useI18n()
const submitting = ref<boolean>(false)

async function submit() {

  submitting.value = true

  Product.destroy(props.product.ID)
    .then(() => {
      NotificationService.success(t('alerts.product_deleted'))
      closeDialog(null)
    })
    .catch((error) => {
      console.error(error)
      NotificationService.error(t('alerts.couldnt_delete_product'))
    })
    .finally(() => {
      submitting.value = false
    })

}

</script>
